module.exports = __webpack_public_path__ + "static/icon_strikes-a2edb617def8f9c23ee5ba7f368c5589.svg";